import 'slick-carousel';
import 'simplelightbox';

export default {
  init() {
    $('.gallery-slider__wrap').each((i, e) => {
      var $e = $(e);
      var prev = $e.find('.wmtm-prev')[0];
      var next = $e.find('.wmtm-next')[0];
      var slidestoShow = $e.attr('wmtm-slidestoshow');
      $e.find('.gallery-slider__slides').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        mobileFirst: true,
        slidesToScroll: 1,
        prevArrow: prev,
        nextArrow: next,
        slides: $e.find('.gallery-slider__slide'),
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: slidestoShow,
            },
          },
        ],
      })
    });

    $('.htheme-gallery__content').each((i, e) => {
      var links = $(e).find('.slick-slide:not(.slick-cloned) a.lightbox-link');
      $(links).simpleLightbox({
        navText: [
          '<div class="lightbox-prev"></div>',
          '<div class="lightbox-next"></div>',
        ],
      });
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/htheme/pagebuilder/components/gallery.js